import { render, staticRenderFns } from "./OPOSUebersichtstabelle.vue?vue&type=template&id=5ba2837e&"
import script from "./OPOSUebersichtstabelle.vue?vue&type=script&lang=ts&"
export * from "./OPOSUebersichtstabelle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports